var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewColumn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.5 10c.271 0 .5.226.5.505v.99c0 .291-.224.505-.5.505H.5a.506.506 0 0 1-.5-.505v-.99C0 10.214.224 10 .5 10Zm0-6c.271 0 .5.22.5.49v3.02c0 .275-.224.49-.5.49H.5C.23 8 0 7.78 0 7.51V4.49C0 4.215.224 4 .5 4Zm0-4c.271 0 .5.226.5.505v.99c0 .291-.224.505-.5.505H.5a.506.506 0 0 1-.5-.505v-.99C0 .214.224 0 .5 0Z"
})));
export default SvgViewColumn;